import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'

export default class Icon extends PureComponent {
  render() {
    const IconSvg = this.props.icon
    return (
      <div style={{ height: '36px', width: '36px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <IconSvg style={{ margin: 0 }} />
      </div>
    )
  }
}

Icon.propTypes = {
  icon: PropTypes.any
}



// WEBPACK FOOTER //
// ./src/components/icon.js